import { Modal } from '@codametrix/ui-components';
import { Button } from '@chakra-ui/react';
import React, { ReactNode } from 'react';
import './styles/index.scss';
export type ActionItem = {
  action: string;
};

type ConfirmHandler = (actionItem?: ActionItem) => void;

export type ConfirmProps = React.PropsWithChildren<{
  title: string;
  helpText?: string;
  display?: boolean;
  strings?: {
    proceed: string;
    dismiss: string;
  };
  actionItem?: ActionItem;
  onConfirm?: ConfirmHandler;
  onDismiss?: ConfirmHandler;
}>;

const noOpHandler = (actionItem?: ActionItem) => {};

const DEFAULT_PROPS = {
  display: true,
  onConfirm: noOpHandler,
  onDismiss: noOpHandler,
  actionItem: {
    action: 'STANDARD_ACTION'
  },
  strings: {
    proceed: 'Accept',
    dismiss: 'Cancel'
  }
};

export const Confirm: React.FC<ConfirmProps> = (passed: ConfirmProps) => {
  const props = { ...DEFAULT_PROPS, ...passed };
  const { title, strings } = props;
  const helpText = props.helpText ? <p>{props.helpText}</p> : <span />;

  const handleConfirm = (event: React.MouseEvent) => {
    event.preventDefault();
    props.onConfirm(props.actionItem);
  };

  const handleDismiss = (event: React.MouseEvent) => {
    event.preventDefault();
    props.onDismiss(props.actionItem);
  };

  const footerChildren = (
    <div className={'confirm-text'}>
      <Button
        variant="solid"
        size="sm"
        className="chakra-primary-button qa-submit-button auto-focus-btn"
        autoFocus
        onClick={handleConfirm}
      >
        {strings.proceed}
      </Button>

      <span style={{ margin: '0 8px' }}>or</span>

      <a
        href="#/dismiss-confirm"
        tabIndex={0}
        className={'chakra-secondary-button qa-cancel-button '}
        onClick={handleDismiss}>
        {strings.dismiss}
      </a>
    </div>
  );

  return props.display ? (
    <div className="confirm">
      <Modal footerChildren={footerChildren} closable={false} title={title}>
        {helpText}
      </Modal>
    </div>
  ) : null;
};

Confirm.displayName = 'Confirm';
